import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {SettingsAmenity} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsDirectoryService} from 'app/services/settings-directory.service';
import {ConstantsService} from '../../../services/constants.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-directory-detailed-view',
    templateUrl: './settings-directory-detailed-view.component.html',
    styleUrls: ['./settings-directory-detailed-view.component.scss']
})

export class SettingsDirectoryDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    data: SettingsAmenity;
    navPosition = 'tab_settings';
    attachments: Array<any> = [];
    noEdit = false;

    constructor(public api: ApiClientService,
                public settingsDirectoryService: SettingsDirectoryService,
                public directoryService: DirectoryService) {
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/corporation_number/${this.settingsDirectoryService.selectedItemData.id}.json`;
        this.settingsDirectoryService.api.patch('domainBD', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsDirectoryService.getCorporations();
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsDirectoryService.selectedItemData.formFields)
            this.settingsDirectoryService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    showNotificationModal(staffOrResident, notificationType): void {
        this.settingsDirectoryService.isNotificationModalShow = true;
        this.settingsDirectoryService.notificationModalStaffOrResident = staffOrResident;
        this.settingsDirectoryService.notificationModalNotificationType = notificationType;
    }

    submitNotificationsField(): void {
        const data = {
            staffNotificationSettings : [
                {
                    action: 'updated_by_staff',
                    enableStatus: this.settingsDirectoryService.updatedByStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsDirectoryService.updatedByStaffMultiselectArray)
                },
                {
                    action: 'updated_by_resident',
                    enableStatus: this.settingsDirectoryService.updatedByResidentCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsDirectoryService.updatedByResidentMultiselectArray)
                }
            ]
        };
        this.onSubmit(data);
    }
    
    submitResidentsNotificationSettings(): void { 
        const data = {
            residentsNotificationSettings : [
                {
                    action: 'profile_changes_approved',
                    enableStatus: this.settingsDirectoryService.updatedApprovedCheckbox ? 1 : 0
                },
                {
                    action: 'profile_changes_declined',
                    enableStatus: this.settingsDirectoryService.updatedDeclinedCheckbox ? 1 : 0
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        this.settingsDirectoryService.selectedItemData[type + 'NotificationSettings'].filter((setting) => {
            if(setting.action == action)
                flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
        });
        return flag;
    }

    editReminder(index) {
        this.settingsDirectoryService.isRemindersModalShow = true;
        this.settingsDirectoryService.selectedReminderIndex = index;
    }

    deleteReminder(index) {
        swal(
            ConstantsService.getSwalConfig('Delete Reminder', 'Are you sure you want to delete reminder?'),
            () => {
              this.settingsDirectoryService.selectedItemData.reminders.splice(index, 1);
                const data = {
                    reminders: this.settingsDirectoryService.selectedItemData.reminders.map(item => ({
                        title: item.title,
                        description: item.description,
                        conditionDefinition: {
                            value: item.conditionDefinition.value,
                            name: item.conditionDefinition.name,
                            isAfter: item.conditionDefinition.isAfter
                        },
                        conditionField: item.conditionField,
                        subject: item.subject,
                        template: item.template,
                        forStaff: item.forStaff,
                        enableStatus: item.enableStatus,
                        userRoles: item.userRoles
                    }))
                };
                const url = `/v1/corporation_number/${this.settingsDirectoryService.selectedItemData.id}.json?expand=reminders`;
                this.api.patch('domainBD', url, data).subscribe(
                    (result) => {
                        this.settingsDirectoryService.selectedItemData = result;
                        this.updateView('Reminder has been removed successfully', false);
                    },
                    error => this.api.errorHandler(error, 'Delete failed!')
                );
            }
        );
    }

    changeReminderStatus(event, index) {
        let data = JSON.parse(JSON.stringify(this.settingsDirectoryService.selectedItemData.reminders));
        data[index].enableStatus = event.target.checked;
        data = data.map((item, i) => ({
            title: item.title,
            description: item.description,
            conditionDefinition: {
                value: item.conditionDefinition.value,
                name: item.conditionDefinition.name,
                isAfter: item.conditionDefinition.isAfter
            },
            conditionField: item.conditionField,
            subject: item.subject,
            template: item.template,
            forStaff: item.forStaff,
            enableStatus: i != index ? item.enableStatus : event.target.checked,
            userRoles: item.userRoles
        }));
        this.onSubmit({reminders: data});
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/settings-directory-detailed-view/settings-directory-detailed-view.component.ts